const dashboard = '/dashboard';
const login = '/login';
const error = '/error';
const rulePlans = 'rule_plan';
const ruleGroups = 'rule_group';
const rules = 'rules';
const program = 'program';
const frequency = 'frequency';
const workflow = 'workflow';
const ruleManagement = 'rule';
const profile = '/profile';
const targetSetting = 'target_setting';
// const targetSettingConfig = 'target_config';
const targetConfiguration = 'target_configuration';
const holiday = 'holiday';
const targetHierarchy = 'target_hierarchy';
const category = 'categories';
const uploadProductImage = 'custom_images';
const contest = 'contest';
const Query = 'queryconfig';
const ruleChangePlans = 'ruleChangePlan';
const bulkRule = 'bulk_rule';
const bulkRuleUpload = 'bulk_rule_upload';
const bulkRuleDownload = 'bulk_rule_download';
const RuleWorkflow = 'rule_workflow';

const routeName = {
  dashboard,
  login,
  error,
  rulePlans,
  ruleGroups,
  rules,
  program,
  frequency,
  workflow,
  ruleManagement,
  profile,
  targetSetting,
  targetConfiguration,
  holiday,
  targetHierarchy,
  category,
  uploadProductImage,
  contest,
  Query,
  ruleChangePlans,
  bulkRuleUpload,
  RuleWorkflow,
  bulkRule,
  bulkRuleDownload,
};

export default routeName;
